import script from "./MCabecalhoTabelaGrupo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MCabecalhoTabelaGrupo.vue?vue&type=script&setup=true&lang=ts"

import "./MCabecalhoTabelaGrupo.vue?vue&type=style&index=0&id=7fe2c30a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fe2c30a"]])

export default __exports__